import { INavLink } from './../interface/nav-link.interface';

export const LIBRARY = 'Library';
export const APPS = 'Apps';
export const PROJECT = 'Project';
export const PROJECTS = 'Projects';
export const RELEASE = 'Release';
export const PROJECT_ADMIN = 'Project Admin';
export const PROJECT_USER = 'Project User';
export const PACKAGE_ADMIN = "package admin";
export const PLATFORM_ADMIN = "platform admin";
export const SUCCESS = "Success";
export const SUCCESSFUL = "Successful";
export const PARTIAL_SUCCESS = 'Partial Success';
export const FAILED = "Failed";
export const NOT_EXECUTED = "Not Executed";
export const UNKNOWN = "Unknown"
export const INPROGRESS = "In Progress";
export const SCENARIO = 'scenario'
export const NO_STARTED = "Not Started"
export const PENDING = "Pending"
export const RUNNING = "Running";
export const CREATED = "Created";
export const SCHEDULED = "Scheduled";
export const DONE = "Done";
export const NONE = "none";
export const APP_VERSIONS = "App versions";
export const PACKAGE_LEAD = "package lead";
export const UPLOAD_TESTS = "Upload Tests";
export const COPY = "Copy";
export const DELETE = "Delete";
export const MODIFY = "Modify";
export const ADD = "Add";
export const RENAME = "Rename";
export const AUTO = "Auto";
export const DOWNLOAD_TESTS = "Download Tests";
export const DOWNLOAD_REPORT = "Download Report";
export const GENERATE_GENAI_SUMMARY = "Generate GenAI Insights";
export const GENERATING_GENAI_SUMMARY = "Generating GenAI Insights";
export const SETTINGS = "Settings";
export const ADD_TAXONOMY = "Add Taxonomy";
export const VIEW_TAXONOMY = "View Taxonomy";
export const VIEW = "View";
export const DOWNLOAD = "Download";
export const APP_VERSION_DETAILS = "Application Version Details";
export const COMPLETED = "Completed";
export const VIDEO = 'Video';
export const REPORT = 'Report';
export const ORACLE = 'Oracle';
export const SAP = 'SAP'
export const ADD_TESTS = "Add Tests";
export const FAULTED = "Faulted";
export const PASSED = "Passed";
export const PASSED_WITH_EXCEPTION = "Passed with exception"
export const QUEUED = "Queued";
export const INITIATED = "Initiated";
export const DEPLOYMENT_FAILED = "Deployment Failed";
export const ADD_CYCLE = 'Add Cycle';
export const ERROR_FILE_DOWNLOAD = "Error occurred while downloading Report";
export const ERROR_TEST_SCENARIO_RERUN = "Rerun is not possible for this test scenario as it does not have any test cases linked with the bot"
export const ERROR_TEST_CASE_RERUN = "Rerun is not possible for this testcase as no bot linked with the testcase";
export const ERROR_DELETING_GENAI_TESTCASES = "Failed to delete GenAI test cases.";
export const ERROR_VIDEO_DOWNLOAD = "Error occurred while downloading Video";
export const DOWNLOAD_VIDEO_PROGRESS = "Video generation with audio has started. It will take some time to add audio to the video. Please wait and come back after some time to download."
export const GENAI_GENERATE_VIDEO = "Generate and Download AI-Enhanced";
export const GENAI_DOWNLOAD_VIDEO = "Download AI-Enhanced";
export const ERROR_SCREEN_SHOTS_DOWNLOAD = "Error occurred while downloading Screenshots";
export const FILE_MISMATCH_ERROR = "Please upload the correct file";
export const ERROR_TEMPLATE_DOWNLOAD = "Error occurred while downloading Template";
export const ERROR_TEMPLATE_UPLOAD = "Error occurred while uploading Template";
export const ERROR_TEMPLATE_STATUS = "Error occurred while uploading Status";
export const TERMINATED = "Terminated";
export const ADD_TEAM_MEMBERS = 'Add Team Members';
export const MANAGE_TEAMS = "Manage Teams";
export const DRAFT = "Draft";
export const ENABLED = "Enabled";
export const DISABLED = "Disabled";
export const EXCEL_UPLOAD_ACTION = "ExcelUpload";
export const MANUAL_UPLOAD_ACTION = "ManualUpload";
export const NOT_FOUND = "Not found";
export const NOT_STARTED = "NOT_STARTED";
export const TAXONOMIES = "Taxonomies";
export const BOT_DICTIONARIES = "Bot Dictionaries";
export const ORCHESTRATOR_SETTINGS = "Orchestrator Setting";
export const TOOL_SETTINGS = "Tool Settings";
export const APPLICATION_UNDER_TESTING_SETTINGS = "Application Under Testing Settings";
export const BOT_DICTIONARY = "Bot Dictionary";
export const BOT_EXECUTION_HISTORY = "Bot Execution History";
export const BOT_SCHEDULER = "Bot Scheduler"
export const ACTIVE = "Active";
export const STATUS = "status";
export const EXPORTED_TIME = "exportedTime";
export const EMPTY_STRING = "";
export const ACTIVE_US_STATUS_TOOL_TIP = "Note: Active User Stories are displayed by default when no filters are applied";
export const BULK_EXPORT_USER_STORIES_FAILED = "Error Occurred while exporting data.";
export const BULK_EXPORT_TEST_SCENARIOS_FAILED = "Error Occurred while exporting data.";
export const EXPORT_ALL_FAILED = "Export all has been failed.";
export const EXPORT_ALL_SUCCESS = "Export has been initiated.";
export const BULK_EXPORT_USER_STORIES_IN_PROGRESS = "Uploading user stories are in progress.";
export const BULK_EXPORT_TEST_SCENERIOS_IN_PROGRESS = "Uploading test scenerios are in progress.";
export const BULK_EXPORT_ALL_TEST_SCENERIOS_SUCCESS = "All test scenarios have been successfully exported.";
export const BULK_EXPORT_ALL_TEST_SCENERIOS_WARNING = "Test scenarios that have associated releases and test cycles without in-progress status will be exported."
export const TEST_SCENARIOS_EXPORT_TOOL_TIP = "Please select at least one row."
export const TEST_SCENARIOS_EXPORT_ALL_TOOL_TIP = "No test scenarios present to export."
export const USER_STORIES_EXPORT_TOOL_TIP = "Please select at least one row."
export const USER_STORIES_EXPORT_ALL_TOOL_TIP = "No user stories present to export."
export const RETIRED = "Retired";
export const UPLOAD_DICTIONARY = "Upload Dictionary";
export const DOWNLOAD_DICTIONARY = 'Download Dictionary';
export const COPY_DICTIONARY = "Copy Dictionary";
export const RENAME_DICTIONARY = "Rename Dictionary";
export const CHANGE_DICTIONARY_STATUS = "Change dictionary status";
export const CHANGE_MCP_STATUS = "Change MCP status";
export const DELETE_DICTIONARY = "Delete Dictionary";
export const PUBLISHED = "Published";
export const COMPLETE = "Complete";
export const APPLICATION_DATA = "Application Data";
export const TEST_DATA = "Test Data";
export const CHANGE_STATUS = "Change Status";
export const CHANGE_PRIORITY = "Change Priority";
export const DESIGN_SETTINGS = "Design settings";
export const ADD_USERS = "Add Users";
export const TOOL_INTEGRATION = "Tool Integration";
export const DELOITTE_ALM_PROJECT = "Deloitte ALM";
export const TRICENTIS_QTEST = "Tricentis qTest";
export const CANCELLED = "Cancelled";
export const DEFECTS = "Defects";
export const USER_STORIES = "User Stories";
export const TEST_SCENARIOS = "Test Scenarios"
export const INVALID_XAML_NAMES = ['Main.xaml', 'start.xaml', 'stop.xaml'];
export const ERROR_VALID_XAML_FILE_NAME = 'This filename is not allowed.Restricted filenames: Main.xaml, start.xaml, stop.xaml';
export const IMPORT_FROM_LIBRARY = "Import from Library";
export const IMPORT_IN_PROGRESS = "Import In Progress";
export const DOWNLOAD_IN_ALM_FORMAT = "download in ALM Format";
export const DOWNLOAD_IN_TEST_AI_FORMAT = "download in Test AI Format";
export const SEARCH = "Search";
export const TEST_SCENARIO_KEY_NAME = "testScenario"
export const USER_STORIES_KEY_NAME = "userStory"
export const GENAI_ENABLED ='GenAIEnabled'
export const CONTROLS_ENABLED = 'ControlsEnabled'
export const SAP_CALM_ENABLED = 'SapCalmEnabled'
export const WEB_SEARCH_ENABLED = 'WebSearchEnabled';
export const LLM_ENABLED = 'LLM_ENABLED';
export const NOT_APPLICABLE = 'NA';
export const LLM = 'llm';
export const REPORT_DOWNLOADED="Report Downloaded Successfully"
export const TEST_SCENARIOS_EXPORT_ERROR_MESSAGE="Failed to export test scenario."
export const TEST_SCENARIOS_EXPORT_SUCCESS_MESSAGE="Test Scenario has been exported successfully."
export const TEST_SCENARIOS_EXPORT_IN_PROGRESS_MESSAGE="Export for Test Scenario has started."
export const USER_STORIES_EXPORT_ERROR_MESSAGE="Failed to export user story."
export const USER_STORIES_EXPORT_SUCCESS_MESSAGE="User story has been exported successfully."
export const USER_STORIES_EXPORT_IN_PROGRESS_MESSAGE="Export for user story has started."
export const QTEST_EXPORT_FAILURE_MESSAGE = "An error occurred while exporting to qTest. Please raise a support ticket";
export const COPY_SUCCESS_MESSAGE="Test case was successfully copied to the integration tests"
export const COPY_FAILED_MESSAGE="Failed to copy the test case to integration tests"
export const COPY_NO_L4_MESSAGE="User story is not mapped to L4"
export const GENAI_TESTCASES_DELETED_MSG = "Gen AI Testcases deleted successfully.";
export const USER_REPORT = "userReports";
export const PROJECT_REPORT = "projectReports";
export const EXTERNAL_USER = "external";
export const DELOITTE_USER_DOMAIN = "deloitte.com";
export const GENERATE_VECTOR_EMBEDDINGS = "Generate Vector Embeddings";
export const REGENERATE_VECTOR_EMBEDDINGS = "Regenerate Vector Embeddings";
export const GENERATE_SCENARIO_EMBEDDINGS = "Generate Scenario Embeddings";
export const REGENERATE_SCENARIO_EMBEDDINGS = "Regenerate Scenario Embeddings";
export const DELETED_SUCCESSFULLY = "Deleted successfully";
export const ORPHAN_TEST_CASES_WARNING = "Test Scenarios that don't have missing Test Cases will be exported.";
export const US_REGION = "US";
export const EU_REGION = "EU";
export const GLOBAL = "Global";
export const TESTAI_API_URL = "/test-ai/api/v1";
export const TOOL_INTEGRATION_URL = "tool-integration/project";
export const LOW = 'low';
export const SAP_CALM = 'SAP CALM'
export const GPT_5_MODEL = 'gpt_5';
export const DEFAULT_LLM_OPTIONS: { label: string; value: string }[] = [
  {
    label: 'GPT-5',
    value: GPT_5_MODEL
  }
];

export const FILE_UPLOADING_MSG = "File is being processed, Please wait";

export const FEATURES = {
  menu: "Menu",
  library: "Library",
  industryPrint: "IndustryPrint",
  applicationVersion: "ApplicationVersion",
  project: "Project",
  botDictionary: "BotDictionary"
}

export const EMBEDDING_STATUS = {
  IN_PROGRESS: "STARTED",
  CREATED: "SUCCESS",
  NOT_STARTED: "Not_Started",
};

export const ACTIONS = {
  projects: "Projects",
  platformAdmin: "Platform Admin",
  library: "Library",
  hideRetiredTaxonomies: "HideRetiredTaxonomies"
}

export const navbarLinks: INavLink[] = [
  {
    label: "Library",
    path: "/library",
    icon: "menu_book"
  },
  {
    label: "Projects",
    path: "/projects",
    icon: "stacks"
  },
  {
    label: "Platform Admin",
    path: "/platform-admin",
    icon: "settings"
  }
]

export const TEMPLATE_URL = {
  start: 'https://amedeloitte.sharepoint.com/:x:/r/sites/Dummy_1693923337815/Shared%20Documents/General/Generative%20AI/Project%20Video%20Generator/',
  end: '/Input%20Data%20Template/Define_Legal_Entities.xlsm?d=w4814bb08ed7a4fee8a6758f6c04c1f3d&csf=1&web=1&e=lxOBbj?d=w67befa65a21447479db910a8273a90bb&csf=1&web=1&e=Mla62b',
  openLinkStart: 'https://amedeloitte.sharepoint.com/:x:/r/sites/Dummy_1693923337815/Shared%20Documents/',
  openLinkEnd: '?csf=1&web=1'
}

export const POLL_REQUEST = {
  EXECUTED: 'Executed',
  IN_PROGRESS: 'In Progress',
  COMPLETED: 'Completed',
  FAILED: 'Failed',
};

export const API_URL = {
  getTestScenarioApiUrl: 'alm/project/projectId/test-scenarios-list',
};

export const USER_STORIES_REPORT = {
  USER_STORY_COVERAGE_REPORT: "User Story Coverage Report",
  USER_STORY_TEST_CASE_COVERAGE: "Test Case Coverage",
  USER_STORY_TEST_SCENARIO_COVERAGE: "Test Scenario Coverage"
}

export const DEFAULT_TEST_CASE_GENERATOR = {
  tabCode: 'Default Test Case Generator',
  botMapCode: 'Bulk Bot Mapping to Test Cases',
  bulkEmbeddingCreationCode: 'Embedding Generation'
}

export const AT_PROJECT_REPORT_CATEGORY = {
  GENAI_USAGE_REPORT: "GEN AI Usage Report",
  GENAI_QUALITY_REPORT: "GEN AI Quality Report",
  PROJECT_BOT_REPORT: "Bot Coverage Report"
};

export const BOT_HISTORY_STATUS = {
  success: 'Success',
  successful: 'Successful',
  failed: 'Failed',
  notExecuted: 'Not Executed',
  unknown: 'Unknown',
  inprogress: 'In Progress',
  pending: 'Pending',
  running: 'Running',
  created: 'Created',
  scheduled: 'Scheduled',
  done: 'Done',
  faulted: 'Faulted',
  passed: 'Passed',
  passedWithException: 'Passed with exception',
  queued: 'Queued',
  initiated: 'Initiated',
  deploymentFailed: 'Deployment Failed',
  stopped: 'Stopped',
  partialSuccess: 'Partial Success'
};

export const TEST_CASE_ACTION = {
  DELETE: "DELETE",
  MODIFY: "MODIFY",
  ADD: "ADD"
}

export const TAG = {
  INITIAL_PLACEHOLDER: 'Type to search or add a new tag',
  LABEL: 'Tags',
  SELECT_PLACEHOLDER:'Type to select tags'
}
export const DEFAULT_PAGE_SIZE = 10;

export const DEFAULT_PAGE_NUMBER = 1;

export const TEST_CASE_DELETE_DISABLED_TOOLTIP = "You cannot delete a Test Case because you are not the owner";

export const PROJECT_TEST_SCENARIO_DELETE_DISABLED_TOOLTIP = "You cannot delete the Test Scenario because you are not part of the design team";

export const LIBRARY_TEST_SCENARIO_DELETE_DISABLED_TOOLTIP = "You cannot delete the Test Scenario because you are not the creator";

export const TEST_SCENARIO_DELETE_DISABLED_TOOLTIP_FOR_DESIGNER = "The user is a Designer. Please update the user to enable the delete button";

export const TEST_SCENARIO_DELETE_DISABLED_TOOLTIP_FOR_REVIEWER = "The user is a Reviewer. Please update the user to enable the delete button";

export const TEST_SCENARIO_DELETE_DISABLED_TOOLTIP_FOR_DESIGNER_REVIEWER = "The user is a Designer and a Reviewer. Please update the user to enable the delete button";

export const TEST_CASES_REPORT_GENERATION_STATUS = {
  PENDING: "PENDING",
  STARTED: "STARTED",
  SUCCESS: "SUCCESS",
  FAILURE: "FAILURE",
};

export const ERROR_OCCURED_WHILE_GENERATING_TEST_CASE_REPORT =
  "Error occured while generating test case report";
export const ERROR_OCCURED_WHILE_FETCHING_TEST_CASE_REPORT_GENERATION_STATUS =
  "Error occured while fetching test case report generation status";

export const GENERATE_BOT_COVERAGE_REPORT = "The report has not been generated yet. Press the button below to generate it."  
export const DOWNLOAD_BOT_COVERAGE_REPORT = "The report is ready and up to date. Click the button below to download it.";
export const REGENERATE_BOT_COVERAGE_REPORT = "The system has been updated. Click the button below to generate a new report.";
export const BOT_COVERAGE_REPORT_GENERATION_STARTED = "Report generation for Bot Coverage Report has started.";
export const BOT_COVERAGE_REPORT_GENERATION_SUCCESS = "Report for Bot Coverage Report has been successfully generated.";
export const BOT_COVERAGE_REPORT_GENERATION_IN_PROGRESS = "Generating report. Some reports may take ~30 min. to generate."

export const ERROR_OCCURED_WHILE_GENERATING_GENAI_REPORT =
  "Error occured while generating genAI report";

export const AGENTIC_VIEW_ENABLED = 'agenticViewEnabled'
export const SELECT_REASONING = 'Just one more step before generating. Please select a reasoning level option to continue.';
export const REASONING_INFO = 'Reasoning level affects response quality and speed – higher settings provide deeper, more thorough results but may take longer to generate.';
